/* eslint-disable no-undef */
import api from '../api'
import Vue from 'vue'
export const CLEAR = 'CLEAR'
export const UPDATE_HALLS = 'UPDATE_HALLS'
export const UPDATE_DEPARTMENTS = 'UPDATE_DEPARTMENTS'
export const UPDATE_OPERATOR = 'UPDATE_OPERATOR'
export const UPDATE_PERIODNAMES = 'UPDATE_PERIODNAMES'
export const UPDATE_POSITIONS = 'UPDATE_POSITIONS'
export const UPDATE_HALLOPS = 'UPDATE_HALLOPS'
export const UPDATE_MANAGERS = 'UPDATE_MANAGERS'
export const UPDATE_ADDRESSRULE = 'UPDATE_ADDRESSRULE'
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS'
export const UPDATE_HALL_TAGS = 'UPDATE_HALL_TAGS'
export const UPDATE_HALL_DISH_LIBRARY = 'UPDATE_HALL_DISH_LIBRARY'
export const UPDATE_HALL_CATEGORIES = 'UPDATE_HALL_CATEGORIES'
export const UPDATE_WAITERS = 'UPDATE_WAITERS' // 更新点餐员(阿姨)
export const UPDATE_ODS_OPERATOR = 'UPDATE_ODS_OPERATOR' // 更新ODS操作员
export const GET_ADVIECES = 'GET_ADVIECES'
export const UPDATE_BASE_MATERIALS = 'UPDATE_BASE_MATERIALS' // 更新原材料数据
export default {
  state: {
    halls: [],
    departments: [],
    operators: [],
    periodNames: [],
    positions: [],
    diningOperators: [],
    managers: [],
    addressRuleList: [],
    addressList: [],
    tags: [],
    dishes: {},
    categories: {},
    waiters: [],
    odsOperators: [],
    patientDoctorAdviceChanges: [],
    totalCount: 0,
    baseMaterials: []
  },
  mutations: {
    [CLEAR] (state, data) {
      Object.assign(state, {
        halls: [],
        departments: [],
        operators: [],
        periodNames: [],
        positions: [],
        diningOperators: [],
        managers: [],
        addressRuleList: [],
        addressList: [],
        tags: [],
        dishes: {},
        categories: {},
        waiters: [],
        odsOperators: [],
        patientDoctorAdviceChanges: []
      })
    },
    [UPDATE_HALLS] (state, data) {
      Object.assign(state, data)
    },
    [GET_ADVIECES] (state, data) {
      // Vue.set(state, data.patientDoctorAdviceChanges, data.totalCount)
      Vue.set(state, 'patientDoctorAdviceChanges', data.patientDoctorAdviceChanges)
      Vue.set(state, 'totalCount', data.totalCount)
    },
    [UPDATE_DEPARTMENTS] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_OPERATOR] (state, data) {
      Object.assign(state.operators, data)
    },
    [UPDATE_PERIODNAMES] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_POSITIONS] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_HALLOPS] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_MANAGERS] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_ADDRESSRULE] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_ADDRESS] (state, data) {
      Object.assign(state, data)
    },
    [UPDATE_HALL_TAGS] (state, data) {
      Object.assign(state.tags, data.tags)
    },
    [UPDATE_HALL_DISH_LIBRARY] (state, data) {
      Vue.set(state.dishes, data.hallId, data.data)
    },
    [UPDATE_HALL_CATEGORIES] (state, data) {
      Vue.set(state.categories, data.hallId, data.data)
    },
    [UPDATE_WAITERS] (state, data) {
      Vue.set(state, 'waiters', data.waiters)
      // Object.assign(state.waiters, data.waiters)
    },
    [UPDATE_ODS_OPERATOR] (state, data) {
      Vue.set(state, 'diningOperators', data.diningOperators)
      Vue.set(state, 'odsOperators', data.diningOperators)
      // Object.assign(state.odsOperators, data.diningOperators)
    },
    [UPDATE_BASE_MATERIALS] (state, data) {
      Vue.set(state, 'baseMaterials', data.list)
    }
  },
  actions: {
    [CLEAR] ({
      commit
    }) {
      commit(CLEAR)
    },
    [UPDATE_HALLS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryHalls(user).then((data) => {
          commit(UPDATE_HALLS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_HALLOPS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryHallOP(user).then((data) => {
          commit(UPDATE_HALLOPS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_DEPARTMENTS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryDepartment(user).then((data) => {
          commit(UPDATE_DEPARTMENTS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_OPERATOR] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryOperator(user).then((data) => {
          commit(UPDATE_OPERATOR, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_PERIODNAMES] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryPeriodNames(user).then((data) => {
          commit(UPDATE_PERIODNAMES, data)
          resolve(data)
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_POSITIONS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryPositions(user).then((data) => {
          commit(UPDATE_POSITIONS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_MANAGERS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryManager(user).then((data) => {
          commit(UPDATE_MANAGERS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_ADDRESSRULE] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryAddressRule(user).then((data) => {
          commit(UPDATE_ADDRESSRULE, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_ADDRESS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryAddress(user).then((data) => {
          commit(UPDATE_ADDRESS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_HALL_TAGS] ({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        api.queryTags(param.user, param.hallId).then((data) => {
          let tagArr = []
          if (param.user.type === 6) {
            tagArr = data.tags.filter(tag => {
              return tag.tagType === 2
            })
          } else {
            tagArr = data.tags.filter(tag => {
              return tag.tagType !== 2
            })
          }
          data.tags = tagArr.sort((a, b) => {
            return a.tagName.localeCompare(b.tagName)
          })
          data.tags.forEach(tag => {
            tag.isShow = true
          })
          commit(UPDATE_HALL_TAGS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    // param 的结构是 {user: user, hallId: hallId}
    [UPDATE_HALL_DISH_LIBRARY] ({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        let params = {
          userId: param.user.managerId,
          companyId: param.user.companyId,
          hallId: param.hallId,
          cateId: param.cateId,
          queryCondition: '',
          itemKind: param.itemKind
        }
        if (param.hasOwnProperty('cateId') === false) {
          params.cateId = '0'
        }
        api.queryBaseDishes(param.user, params).then((data) => {
          commit(UPDATE_HALL_DISH_LIBRARY, {
            data: data.items,
            hallId: param.hallId
          })
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    // param 的结构是 {user: user, hallId: hallId}
    [UPDATE_HALL_CATEGORIES] ({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        api.queryCategories(param.user, param.hallId).then((data) => {
          commit(UPDATE_HALL_CATEGORIES, {
            data: data.cates,
            hallId: param.hallId
          })
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_WAITERS] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryWaiter(user).then((data) => {
          commit(UPDATE_WAITERS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_ODS_OPERATOR] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryOdsOperator(user).then((data) => {
          commit(UPDATE_ODS_OPERATOR, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [GET_ADVIECES] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.queryDoctorAdvice(user).then((data) => {
          commit(GET_ADVIECES, {
            patientDoctorAdviceChanges: data.patientDoctorAdviceChanges,
            totalCount: data.totalCount
          })
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    },
    [UPDATE_BASE_MATERIALS] ({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        api.queryMaterials2(param.user, param.param).then((data) => {
          commit(UPDATE_BASE_MATERIALS, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/baseinfo.js